// extracted by mini-css-extract-plugin
export default {"hub":"NavBar_hub__WGo4m","title":"NavBar_title__I4Vq9"};